import { IIntegration } from '@/entities/integrations';
import { Switch } from '@/shared/ui/Switch';

import { useUpdateIntegration } from '../../model/useUpdateIntegration';

type TIntegrationsActiveSwitcherProps = {
  integration: IIntegration;
};

export const IntegrationActiveSwitcher = ({
  integration,
}: TIntegrationsActiveSwitcherProps) => {
  const { updateIntegration, isPending } = useUpdateIntegration();

  const handleToggleActive = async (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    await updateIntegration({
      account_id: integration.gochat_account_id,
      integra_id: integration.integra_id,
      provider_type: integration.provider_type,
      is_active: checked,
    });
  };

  return (
    <Switch
      checked={integration.is_active}
      onChange={handleToggleActive}
      disabled={isPending}
    />
  );
};
